import { END_POINT_SEVER } from "../constants";
import axios from "axios";
import {
  SuccessSwal,
  WarningError,
  WarningNetworkFailure,
  WarningSwal,
} from "../helpers/alertseet";
import convertMessage from "../helpers/convertMessage";
import { jwtDecode } from "jwt-decode";

export const get_members = async (findby = "", token) => {
  try {
    const decoded = jwtDecode(token);
    let url = `${END_POINT_SEVER}/api/member/getAllMember${findby}branchId=${decoded?.branchId}`;
    url += "&isDelete=false"; // ບໍ່ໂຊລາຍການທີລົບແລ້ວ
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const get_member = async (_id, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/member/get/${_id}`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const get_membe_by_member_no = async (memberNo, token) => {
  try {
    const decoded = jwtDecode(token);
    const url = `${END_POINT_SEVER}/api/member/getMemberByMemberNo/${memberNo}?branchId=${decoded?.branchId}&isDelete=false`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const add_member = async (data, token) => {
  try {
    const decoded = jwtDecode(token);
    const url = `${END_POINT_SEVER}/api/member/create`;
    const res = await axios.post(
      url,
      { ...data, branchId: decoded?.branchId },
      {
        headers: { authorization: `Bearer ${token}` },
      }
    );
    SuccessSwal("ສ້າງບັນຊີສຳເລັດ!");
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const update_member = async (_id, data, token) => {
  try {
    const decoded = jwtDecode(token);
    const url = `${END_POINT_SEVER}/api/member/update/${_id}`;
    const res = await axios.put(
      url,
      { ...data, branchId: decoded?.branchId },
      {
        headers: { authorization: `Bearer ${token}` },
      }
    );
    SuccessSwal("ແກ້ໄຂບັນຊີສຳເລັດ!");
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const delete_member = async (_id, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/member/delete/${_id}`;
    const res = await axios.delete(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    SuccessSwal("ລຶບບັນຊີສຳເລັດ!");
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};
